import type { FC, ReactNode } from 'react'

import { ListChecks } from 'lucide-react'

import { cn } from '@/lib/utils'

interface TldrBoxProps {
    // Stored as HTML (a <ul> of 3-5 bullets) authored in the rich-text editor.
    content: string
    className?: string
}

// Key Takeaways box. Sits near the top of every article and pillar page because
// this is the block AI Overviews and chatbots most often lift verbatim.
export const TldrBox: FC<TldrBoxProps> = ({ content, className }): ReactNode => {
    return (
        <aside
            className={cn(
                'rounded-2xl border border-border bg-secondary/40 p-6 sm:p-7',
                className
            )}
            aria-labelledby='key-takeaways'
        >
            <h2
                id='key-takeaways'
                className='flex items-center gap-2 font-heading text-sm font-semibold uppercase tracking-[0.12em] text-foreground'
            >
                <ListChecks className='size-4 text-primary' />
                Key takeaways
            </h2>

            <div
                className='tldr-content mt-4 text-[0.95rem] leading-relaxed text-foreground/85'
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </aside>
    )
}
